export const LogoMark = ({ className = "h-9 w-9" }) => (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <rect width="64" height="64" rx="14" fill="#0B132B" stroke="rgba(255,255,255,0.14)" />
        <path d="M14 14 L30 30" stroke="#F8FAFC" strokeWidth="4.5" strokeLinecap="round" />
        <path d="M50 14 L34 30" stroke="#F8FAFC" strokeWidth="4.5" strokeLinecap="round" />
        <path d="M14 50 L30 34" stroke="#FF3366" strokeWidth="4.5" strokeLinecap="round" />
        <path d="M50 50 L34 34" stroke="#FF6B35" strokeWidth="4.5" strokeLinecap="round" />
        <circle cx="32" cy="32" r="6.5" fill="#FF3366" />
    </svg>
);

export default function Logo() {
    return (
        <a href="#top" data-testid="logo-link" className="group flex shrink-0 items-center">
            <img
                src="/focs-wordmark.png"
                alt="FocS Global — Influencer Marketing Agency"
                className="h-8 w-auto transition-opacity duration-300 group-hover:opacity-80 sm:h-9"
            />
        </a>
    );
}
